import { Component } from "react";
import PropTypes from "prop-types";

class GenericErrorBoundary extends Component {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  static propTypes = {
    children: PropTypes.node,
    fallbackComponent: PropTypes.node
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }


  componentDidCatch(error, info) {
    console.error(info, error);
  }

  render() {
    const { children, fallbackComponent } = this.props;
    if (this.state.hasError) {
      // Render the fallback if there's an error
      return fallbackComponent;
    }

    return children;
  }
}

export default GenericErrorBoundary;
